module.exports = __webpack_public_path__ + "img/team.ab00d84b.png";